<template>
  <div>
    <p class="mb-4 text-sm text-support-light">
      Which service do you send your newsletters with?
    </p>

    <div class="mx-auto max-w-xs">
      <Selector
        class="mb-4 w-full services-selector"
        name="services-selector"
        :options="services"
        :value="selectorValue"
        :clearable="false"
        placeholder="Choose your provider..."
        :disabled="downloading"
        @input="onServiceSelected"
      />

      <div v-if="otherSelected" class="mt-2 max-w-xs mx-auto">
        <label for="other" class="hidden">
          Other
        </label>

        <Input
          :value="otherValue"
          name="other"
          type="text"
          placeholder="Who is the other provider?"
          class="other-input"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/UI/Input";
import Selector from "@/components/UI/Selector";
import mailchimpLogo from "@/assets/images/logos/mailchimp.png";
import campaignMonitorLogo from "@/assets/images/logos/campaign-monitor.svg";
import hubspotLogo from "@/assets/images/logos/hubspot.svg";
import aweberLogo from "@/assets/images/logos/aweber.png";
import constantContactLogo from "@/assets/images/logos/constant-contact.png";
import omnisendLogo from "@/assets/images/logos/omnisend.png";
import pabblyLogo from "@/assets/images/logos/pabbly.png";
import iContactLogo from "@/assets/images/logos/iContact.png";
import sendinblueLogo from "@/assets/images/logos/sendinblue.png";
import activecampaignLogo from "@/assets/images/logos/activecampaign.png";
import autopilotLogo from "@/assets/images/logos/autopilot.png";
import getresponseLogo from "@/assets/images/logos/getresponse.png";
import ontraportLogo from "@/assets/images/logos/ontraport.png";

const services = [
  {
    label: "Mailchimp",
    value: "mailchimp",
    imageUrl: mailchimpLogo,
  },
  {
    label: "Campaign Monitor",
    value: "campaign-monitor",
    imageUrl: campaignMonitorLogo,
  },
  {
    label: "Hubspot",
    value: "hubspot",
    imageUrl: hubspotLogo,
  },
  {
    label: "Aweber",
    value: "aweber",
    imageUrl: aweberLogo,
  },
  {
    label: "Constant Contact",
    value: "constant-contact",
    imageUrl: constantContactLogo,
  },
  {
    label: "Omnisend",
    value: "omnisend",
    imageUrl: omnisendLogo,
  },
  {
    label: "Pabbly",
    value: "pabbly",
    imageUrl: pabblyLogo,
  },
  {
    label: "iContact",
    value: "icontact",
    imageUrl: iContactLogo,
  },
  {
    label: "SendinBlue",
    value: "sendinblue",
    imageUrl: sendinblueLogo,
  },
  {
    label: "ActiveCampaign",
    value: "activecampaign",
    imageUrl: activecampaignLogo,
  },
  {
    label: "AutoPilot",
    value: "autopilot",
    imageUrl: autopilotLogo,
  },
  {
    label: "GetResponse",
    value: "getresponse",
    imageUrl: getresponseLogo,
  },
  {
    label: "Ontraport",
    value: "ontraport",
    imageUrl: ontraportLogo,
  },
  {
    label: "Other",
    value: "other",
  },
];

export default {
  name: "DownloadSenders",
  components: { Input, Selector },
  props: {
    downloading: {
      type: Boolean,
      default: false,
    },
    otherValue: {
      type: String,
      default: "",
    },
    selectorValue: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      services,
    };
  },
  computed: {
    otherSelected() {
      return this.selectorValue?.value === "other";
    },
  },
  methods: {
    onOtherInput(otherValue) {
      this.$emit("other-value", otherValue);
    },
    onServiceSelected(selectorValue) {
      this.$emit("selector-value", selectorValue);

      if (selectorValue.value !== "other") this.$emit("other-value", "");
    },
  },
};
</script>
